export const GET_INFO = 'GET_INFO'

//Header------------------------------------------------------
export const SET_HEADER_CV = 'SET_HEADER_CV'
export const SET_HEADER_AVATAR_URL = 'SET_HEADER_AVATAR_URL'

//Social Links------------------------------------------------
export const SET_SOCIAL_LINKS = 'SET_SOCIAL_LINKS'

//Home------------------------------------------------
export const SET_HOME_INFO = 'SET_HOME_INFO'
